export default {
  votedOn: "Voted on",
  downloadDetails: "Download details (pdf)",
  timeRemaining: "Status",
  startsIn: "Starts in",
  days: "days",
  participants: "Participants",
  voting: "Voting",
  anonymousAndSecure: "Anonymous and secure",
  sectionDescription: "Participate in decisions that affect you!",
  votes: "votes",
  vote: "vote",
  voted: "Voted",
  won: "Won",
  selectOption: "Select",
  selectedOption: "Selected",
  info: {
    revote:
      "Once you vote, you can vote again. The last vote you cast before the voting closes will be the one that counts.",
    anonymous: "Your vote will be anonymous and securely registered on the blockchain.",
  },
  error: {
    votingNotFound: "Voting not found",
  },
  cannotVoteInfo: {
    title: "Why can't I vote?",
    message:
      "To vote, your account must appear as verified and you will only be able to participate in new consultations created from the moment of that validation.\n\nWelcome!",
  },
  secondRound: {
    title: "Second round",
    message:
      "Since a majority (+51%) has not been reached, a second round will be held with the two candidates who received the most votes.",
  },
}
